import React, { useCallback, useEffect, useState } from "react";
import CompanyProfileCard from "../Components/CompanyProfileCard";
import axiosInstance from "../axiosinstance";
import "../Tables/Table.css";
import "./SettingsPage.css";

function SettingsPage({ isSidebarExpanded }) {
  const [companyProfile, setCompanyProfile] = useState(null);
  const [isCompanyLoading, setIsCompanyLoading] = useState(true);
  const [companyError, setCompanyError] = useState("");

  const fetchCompanyProfile = useCallback(async () => {
    try {
      setIsCompanyLoading(true);
      setCompanyError("");
      const response = await axiosInstance.get("/api/firm/profile");
      setCompanyProfile(response?.data || null);
    } catch (error) {
      setCompanyError(
        error?.response?.data?.message || "Failed to load company profile."
      );
    } finally {
      setIsCompanyLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCompanyProfile();
  }, [fetchCompanyProfile]);

  return (
    <div
      className={`settings-page ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="settings-page-shell oa-attached-panel">
        <div className="settings-page-title-row oa-attached-panel__header-cap">
          <h2 className="jost-bold settings-page-title">Settings</h2>
        </div>

        <div className="settings-page-section oa-attached-panel__body">
          <CompanyProfileCard
            company={companyProfile}
            loading={isCompanyLoading}
            error={companyError}
            onRefresh={fetchCompanyProfile}
          />
        </div>
      </div>
    </div>
  );
}

export default SettingsPage;
